<template>
  <v-container class="mt-4 ml-2" fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-title primary-title>
            <span class="text-subtitle-1">Horas Extras</span>
            <v-spacer></v-spacer>

             <v-btn
              color="primary"
              dark
              class="mr-2" 
              @click="goNomina()"
              small
              tile
            >
              Nómina
            </v-btn>

            <v-btn
              color="primary"
              dark
              class="text-capitalize"
              @click="initialize(),  allsueldoHora();"
              small
              tile
            >
              <v-icon left small>mdi-refresh</v-icon>
              Actualizar
            </v-btn>
          </v-card-title>

          <v-card-text>
            <v-row>
              <v-col cols="12" md="3" >
                <v-text-field
                  filled          
                  label="Fecha"
                  type="date"
                  hide-details
                  v-model="fecha"
                  dense
                  @keyup.enter="initialize()"
                  clearable
                ></v-text-field>
              </v-col>             
              <v-col cols="3" md="3" lg="3">
                <v-autocomplete
                  label="Estatus"
                  id="id"
                  filled
                  dense
                  hide-details
                  v-model="estatus"
                  :items="[
                    { id: 0, nombre: 'En revisión' },
                    { id: 1, nombre: 'Aceptado'  },
                    { id: 2, nombre: 'Rechazado' },             
                  ]"
                  item-text="nombre"
                  item-value="id"
                  clearable
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  name="name"
                  label="Buscar"
                  id="id"
                  filled
                  dense
                  hide-details
                  append-icon="mdi-magnify"
                  v-model="search"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-data-table
                  :headers="headers"
                  :items="filterHorasExtras"
                  class="elevation-0"
                  :search="search"
                  :page.sync="page"
                  @page-count="pageCount = $event"
                  :mobile-breakpoint="100"
                  dense
                >

                  <template v-slot:item.cantidad_horas="{ item }">
                    <span v-if="item.tipo == 1">1 Día</span>
                    <span v-if="item.tipo == 2">{{ item.cantidad_horas }}</span>
                  </template>
                  
                  <template v-slot:item.hora_inicio="{ item }">
                    <span >{{ item.hora_inicio }} a {{ item.hora_fin }} </span>
                  </template>


                  <template v-slot:item.escuela="{ item }">
                    <v-chip color="blue"  small dark v-if="item.escuela == 1"
                      >INBI</v-chip
                    >
                    <v-chip color="red" small dark v-if="item.escuela == 2"
                      >FAST</v-chip
                    >
                  </template>


                  <template v-slot:item.estatus="{ item }">
                    <v-chip color="orange"  small dark v-if="item.estatus == 0"
                      >En revisión</v-chip
                    >
                    <v-chip color="green" small dark v-if="item.estatus == 1"
                      >Aceptado</v-chip
                    >
                    <v-chip color="black" small dark v-if="item.estatus == 2"
                      >Rechazado</v-chip
                    >
                  </template>

                  <template v-slot:item.estatus_jefe="{ item }">
                    <v-chip color="orange"  small dark v-if="!item.estatus_jefe"
                      >Pendiente</v-chip
                    >
                    <v-chip color="green" small dark v-if="item.estatus_jefe == 1"
                      >Aceptado</v-chip
                    >
                    <v-chip color="black" small dark v-if="item.estatus_jefe == 2"
                      >Rechazado</v-chip
                    >
                  </template>

                  <template v-slot:item.aceptar="{ item }">
                        <v-btn
                        color="primary"
                        dark
                        small
                        @click="
                            (horaextramensaje = item), (dialogAceptar = true)
                        "
                        >
                        ACEPTAR
                        </v-btn>
                  </template>

                    <!--BOTON Rechazar -->
                  <template v-slot:item.rechazar="{ item }">
                        <v-btn
                        color="secondary"
                        dark
                        small
                        @click="
                            (idhistorial = item),
                            (dialog_mensaje_rechazo = true),
                            getMensajesRechazo()
                        "
                        >
                        RECHAZAR
                        </v-btn>
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <v-icon small @click="deleteItem(item)" color="error">
                      mdi-delete
                    </v-icon>
                  </template>

                  <template v-slot:no-data>
                    <v-btn color="primary" @click="initialize" small>
                      Actualizar
                    </v-btn>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

     <v-dialog v-model="dialogAceptar" max-width="500px">
      <v-card>
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <v-card class="elevation-0" height="100%" style="display: table">
                <div
                  class="text-h6"
                  style="display: table-cell; vertical-align: middle"
                >
                  <strong>Aceptar:</strong> ¿Estás seguro que deseas aceptar las horas extras?
                  <v-card-actions class="pt-6">
                    <!-- Cerrar dialogo de confirmación y abrir el dialogo de editar la clase -->
                    <v-btn
                      color="error"
                      text
                      large
                      class="mr-2"
                      @click="dialogAceptar=false"
                      >No, cancelar</v-btn
                    >
                    <!-- Guardar la información  -->
                    <v-btn
                      color="#5C5C5C"
                      dark
                      class="elevation-6"
                      large
                      @click="aceptarHorasExtras()"
                      >Si</v-btn
                    >
                  </v-card-actions>
                </div>
              </v-card>
            </v-col>
            <v-col cols="6">
              <v-img src="@/assets/contrato.jpg"></v-img>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_mensaje_rechazo" max-width="1000px" persistent>
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1"><b>Favor de aclarar el motivo del rechazo:</b></span>
          <v-spacer></v-spacer>
          <span class="text-subtitle-1">
            <strong>ID:</strong>
          </span>
        </v-card-title>

        <v-card-text>
          <v-row v-for="(item, index) in this.mensajes" :key="index">
            <v-col cols="12">
              <v-textarea
                v-model="item.nota"
                :id="'motivo_salida_' + index"
                label="Motivo del rechazo"
                outlined
                hide-details
                dense
                auto-grow
                readonly
                style="max-width: 900px; margin-right: auto"
              ></v-textarea>
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="item.nota_respuesta"
                :id="'motivo_salida_' + index"
                label="Respuesta..."
                outlined
                hide-details
                dense
                auto-grow
                readonly
                style="max-width: 900px; margin-left: auto"
                :class="{ 'd-none': !item.nota_respuesta }"
              ></v-textarea>
            </v-col> </v-row
          ><br />
          <v-row
            style="border: 1px solid gray; padding: 2px; border-radius: 5px"
            v-if="idhistorial.estatus == 0 || idhistorial.estatus == 2"
          >
            <v-col cols="12" :style="{ paddingTop: '10px' }">
              <v-textarea
                v-model="editedItem2.mensaje"
                label="Escriba su mensaje..."
                outlined
                hide-details
                dense
                auto-grow
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="
              (dialog_mensaje_rechazo = false), (editedItem2.mensaje = '')
            "
          >
            Cancelar
          </v-btn>
          <v-btn
            color="blue darken-1"
            class="elevation-6"
            dark
            @click="enviarMensajeRechazo()"
          >
            Enviar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de carga -->
    <Alerta v-if="respuestaAlerta" :parametros="parametros" />
    <carga v-if="cargar" />
  </v-container>
</template>
<script>
import axios from 'axios';
import { mapGetters } from "vuex";
// Componentes
import Alerta from "@/components/alertas/Alerta.vue";
import carga from "@/components/alertas/carga.vue";

import validarErrores from "@/mixins/validarErrores";
import funcionesExcel from "@/mixins/funcionesExcel";

export default {
  mixins: [validarErrores, funcionesExcel],

  components: {
    Alerta,
    carga,
  },

  data: () => ({
    // Alertas
    parametros: {
      dialogError: false,
      mensaje: "",
      color: "",
    },

    respuestaAlerta: false,
    loader: true,
    cargar: false,

    dialog: false,
    dialogAsistencias: false,
    dialogDelete: false,
    dialogAceptar: false,
    headers: [
      { text: "ID", align: "start", value: "idhoras_extras" },
      { text: "Nombre", value: "nombre_completo" },
      { text: "Fecha", value: "fecha" },
      { text: "Hora Entrada", value: "hora_inicio" },
      { text: "Horas Extras", value: "cantidad_horas" },
      { text: "Sueldo Hora", value: "sueldo_hora" },
      { text: "Monto Horas Extras", value: "monto_final" },
      { text: "Escuela", value: "escuela" },
      { text: "Plantel", value: "plantel" },
      { text: "Razón/Notas", value: "notas" },
      { text: "Estatus", value: "estatus" },
      // { text: "Aceptar", value: "aceptar" },
      // { text: "Rechazar", value: "rechazar" },
    ],
    headersEmpleados: [
      { text: "ID", align: "start", value: "id" },
      { text: "Nombre", value: "nombre_completo" },
      { text: "Plantel", value: "plantel" },
      { text: "Puesto", value: "puesto" },
      { text: "Asistencias", value: "asistencias" },

    ],
    headersAsistencias: [
      { text: "Hora Entrada", value: "hora_entrada" },
      { text: "Hora Salida", value: "hora_salida" },
      { text: "Chequeo Entrada", value: "chequeo_entrada" },
      { text: "Chequeo Salida", value: "chequeo_salida" },
      { text: "¿Regular?", value: "regular" },
      { text: "Horas Extras", value: "horas_extras" },
      { text: "Horas Negativas", value: "horas_negativas" },
      { text: "Horas Trabajo", value: "horas_trabajo" },
      { text: "Horas Trabajadas", value: "horas_trabajadas" },
      { text: "Aceptar", value: "aceptar" },
    ],
    horasextras: [],
    editedIndex: -1,
    editedItem: {
      idhoras_extras: "",
      fecha: "",
      hora_inicio: "",
      hora_fin: "",
      cantidad_horas: "",
      notas: "",
      estatus: 0,
      id_creo: ""
    },
    defaultItem: {
      idhoras_extras: "",
      fecha: "",
      hora_inicio: "",
      hora_fin: "",
      cantidad_horas: "",
      notas: "",
      estatus: 0,
      id_creo: ""
    },

    dialogSuccess: false,
    overlay: false,
    dialogError: false,
    error: "",
    successMensaje: "",
    errorBack: false,
    textoCopiado: "COPIAR",
    idcurso: 0,
    info: 0,
    dialog_mensaje_rechazo: false,
    idhistorial: [],
    fecha: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    horaextramensaje: null,
    editedItem2: {
      mensaje: "",
    },
    mensajes: [],

    ciclos: [],
    ciclo: null,
    estatus: null,
    alumnos: [],
    reglas: [],
    sueldoHora: [],
    cursosEscuela: [],
    resultado: [],
    horasExtras: "",
    // tabla
    search: "",
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
  }),

  computed: {
    ...mapGetters("login", ["getdatosUsuario"]),
    formTitle() {
      return this.editedIndex === -1
        ? "Agregar Horas Extras"
        : "Editar Horas Extras";
    },

    filterHorasExtras() {

       if (this.estatus  ||  this.estatus == 0) {        
        return this.resultado.filter((el) => {
          return el.estatus == this.estatus;
        });
      }
      else {
        return this.resultado;
      }
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },

    "editedItem.escuela"(val) {
      this.cursosEscuela = this.cursos.filter((el) => {
        return el.escuela == val;
      });
    },
  },

  created() {

    if( [334,1].includes( this.getdatosUsuario.iderp ) ){
      this.headers = [
        { text: "ID"                , value: "idhoras_extras"   },
        { text: "Nombre"            , value: "nombre_completo"  },
        { text: "Fecha"             , value: "fecha"            },
        { text: "Hora Entrada"      , value: "hora_inicio"      },
        { text: "Hora Salida"       , value: "hora_fin"         },
        { text: "Horas Extras"      , value: "cantidad_horas"   },
        { text: "Minutos Extras"    , value: "cantidad_minutos" },
        { text: "Sueldo Hora"       , value: "sueldo_hora"      },
        { text: "Sueldo Día"        , value: "sueldo_dia"       },
        { text: "Monto Horas Extras", value: "monto_final"      },
        { text: "Escuela"           , value: "escuela"          },
        { text: "Plantel"           , value: "plantel"          },
        { text: "Razón/Notas"       , value: "notas"            },
        { text: "Estatus"           , value: "estatus"          },
        { text: "Estatus Jefe"      , value: "estatus_jefe"     },
        { text: "Jefe"              , value: "jefe"             },
        { text: "Aceptar"           , value: "aceptar"          },
        { text: "Rechazar"          , value: "rechazar"         },
      ]
    }else{
      this.headers = [
        { text: "ID"            , value: "idhoras_extras"   },
        { text: "Nombre"        , value: "nombre_completo"  },
        { text: "Fecha"         , value: "fecha"            },
        { text: "Hora Entrada"  , value: "hora_inicio"      },
        { text: "Hora Salida"   , value: "hora_fin"         },
        { text: "Horas Extras"  , value: "cantidad_horas"   },
        { text: "Minutos Extras", value: "cantidad_minutos" },
        { text: "Escuela"       , value: "escuela"          },
        { text: "Plantel"       , value: "plantel"          },
        { text: "Razón/Notas"   , value: "notas"            },
        { text: "Estatus"       , value: "estatus"          },
        { text: "Estatus Jefe"  , value: "estatus_jefe"     },
      ]

    }

    console.log( this.$route.params.fecha )

    this.fecha = this.$route.params.fecha ? this.$route.params.fecha : (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
    this.search = this.$route.params.nombre ? this.$route.params.nombre : ''

    this.initialize();
    this.allsueldoHora();
  },

  methods: {
    initialize() {
      this.horasextras = [];
      this.overlay = true;

      const payload = {
        id_creo: this.getdatosUsuario.iderp,
        fecha:  this.fecha
      };

      this.$http.post("horas_extras.get.horasextrasall", payload).then((response) => {
        console.log( response.data )
        this.horasextras = response.data;
        this.overlay = false;
      }).catch((error) => {
        this.validarError( error.response.data.message )
      });
    },

    allsueldoHora () {
      this.cargar = true
      this.sueldoHora = []

      const payload = {
        fecha:    this.fecha,   
      }
      return this.$http.post('usuarios.entradas', payload).then(response=>{

        this.sueldoHora = response.data.result3.filter(item => item.hasOwnProperty('sueldo_hora'));

        console.log( response.data.result3 )

        this.sueldoHora = this.sueldoHora.map(objeto => {
          return {
            sueldo_hora: objeto.id_puesto == 82 ? '$100.00' : objeto.sueldo_hora,
            sueldo_dia: objeto.sueldo_dia,
            id: objeto.id,
            id_usuario: objeto.id_usuario
          };
        });

        // Recorremos los 
        for (const sueldohorass of this.sueldoHora) {

          for (const horaextrass of this.horasextras) {

            const { tipo } = horaextrass
            const { sueldo_hora, sueldo_dia } = sueldohorass


            if (horaextrass.id_creo === sueldohorass.id_usuario) {
              horaextrass.sueldo_hora   = tipo == 2 ? sueldo_hora : '';
              horaextrass.sueldo_dia    = tipo == 1 ? sueldo_dia : '';
              horaextrass.monto_horas   = (parseFloat(sueldo_hora.replace(/[$,]/g, '')) * parseFloat(horaextrass.cantidad_horas)).toFixed(2);
              horaextrass.monto_minutos = (parseFloat(sueldo_hora.replace(/[$,]/g, '')) * parseFloat((horaextrass.cantidad_minutos)/60)).toFixed(2);
          

              horaextrass.monto_final   = tipo == 1 ?  '$' + parseFloat(sueldo_dia).toFixed(2)  : '$' + (parseFloat(horaextrass.monto_horas) + parseFloat(horaextrass.monto_minutos)).toFixed(2);
            }
          }
        }

        this.resultado = this.horasextras

      }).catch( error =>{
        this.validarError( error.response.data.message )
      }).finally( () => { this.cargar = false })
    },

    editItem(item) {
      this.editedIndex = this.incidencias.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    editItem2(item) {
      this.editedItems = Object.assign({}, item)
      this.dialogAsistencias = true
    },

    deleteItem(item) {
      this.editedIndex = this.horasextras.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      // Lo mandapos por el EP
      this.editedItem.deleted = 1;

      this.$http
        .put(
          "horas_extras.update/" + this.editedItem.idhoras_extras,
          this.editedItem
        )
        .then((response) => {
          this.dialogSuccess = true;
          this.overlay = false;
          this.closeDelete();
          this.initialize();
        })
        .catch((error) => {
          // INdicamos que hay un error en el back
          if (error.body.message) {
            this.error = error.body.message;
          } else {
            this.error = error.body;
          }
          this.errorBack = true;
          this.overlay = false;
          this.dialogError = true;
        });
    },

    close() {
      this.dialog = false;
      this.dialogAsistencias = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      //   if (this.editedItem.regla == "") {
      //     this.error = "Favor de llenar todos los campos";
      //     this.errorBack = false;
      //     this.overlay = false;
      //     this.dialogError = true;
      //     return;
      //   }
      if (this.editedIndex > -1) {
        // Activamos el loader
        this.overlay = true;
        this.editedItem.deleted = 0;
        // Lo mandapos por el EP
        this.$http
          .put(
            "reglamento.escuela.update/" + this.editedItem.idreglamento,
            this.editedItem
          )
          .then((response) => {
            this.dialogSuccess = true;
            this.initialize();
            this.overlay = false;
          })
          .catch((error) => {
            // INdicamos que hay un error en el back
            if (error.body.message) {
              this.error = error.body.message;
            } else {
              this.error = error.body;
            }
            this.errorBack = true;
            this.overlay = false;
            this.dialogError = true;
          });
      } else {
        // Activamos el loader
        this.overlay = true;
        this.editedItem.id_creo = this.getdatosUsuario.iderp;
        this.editedItem.cantidad_horas = this.horasExtras;
        // Lo mandapos por el EP
        this.$http
          .post("horas_extras.add.horasextras", this.editedItem)
          .then((response) => {
            this.dialogSuccess = true;
            this.initialize();
            this.overlay = false;
          })
          .catch((error) => {
            // INdicamos que hay un error en el back
            if (error.body.message) {
              this.error = error.body.message;
            } else {
              this.error = error.body;
            }
            this.errorBack = true;
            this.overlay = false;
            this.dialogError = true;
          });
      }
      this.close();
    },

    copiarPortapapeles() {
      navigator.clipboard
        .writeText(this.error)
        .then(() => {
          this.textoCopiado = "COPIADO";
        })
        .catch((err) => {
          console.log("Something went wrong", err);
        });
    },

    //Trae la informacion de toda la fila de alumnos en "Agregar Incidencia"
    infoAlumnos() {
      const alumnoSeleccionado = this.alumnos.find(
        (alumno) => alumno.iderp === this.editedItem.idusuarioerp
      );

      this.info = alumnoSeleccionado.tipo_curso;
     
    },

    getMensajesRechazo() {
      this.cargar = true;
      this.mensajes = [];

      const payload = {
        idhoras_extras: this.idhistorial.idhoras_extras,
        iderp: this.idhistorial.id_creo,
      };
      return this.$http
        .post("consultar.mensajes.rechazo.horasextras", payload)
        .then((response) => {
          this.mensajes = response.data;
          this.cargar = false;
        })
        .catch((error) => {
          this.validarError(error);
        })
        .finally(() => {
          this.cargar = false;
        });
    },


     enviarMensajeRechazo() {
      this.cargar = true;
      const payload = {
        idhoras_extras: this.idhistorial.idhoras_extras,
        nota: this.editedItem2.mensaje,
        iderp: this.idhistorial.id_creo,
        id: this.idhistorial.idhoras_extras,
        estatus: 2,
      };
      return this.$http
        .post("add.horasextras.mensaje", payload)
        .then((response) => {
          this.$http
            .post("update.estatus.horasextras", payload)
            .then((response) => {
              this.validarSuccess(response.data.message);
              this.cargar = false;
              this.dialog_mensaje_rechazo = false;
              this.initialize();
              this.editedItem2.mensaje = null;
            })
            .catch((error) => {
              this.validarError(error);
            })
            .finally(() => {
              this.cargar = false;
            });
        })
        .catch((error) => {
          this.validarError(error);
        })
        .finally(() => {
          this.cargar = false;
        });
    },


    enviarMensajeRespuesta() {
      this.cargar = true;
      const payload = {
        nota_respuesta: this.editedItem2.mensaje,
        idhoras_extras: this.idhistorial.idhoras_extras,
        id_horas_extras2: this.idhistorial.idhoras_extras2,
        iderp: this.idhistorial.iderp,
        iderp2: this.idhistorial.iderp,

        id: this.idhistorial.idhoras_extras,
        estatus: 0,
      };

      
      return this.$http
        .post("update.horasextras.mensaje.respuesta", payload)
        .then((response) => {
          this.$http
            .post("update.estatus.horasextras", payload)
            .then((response) => {
              this.validarSuccess(response.data.message);
              this.cargar = false;
              this.dialog_mensaje_rechazo = false;
              this.initialize();
              this.editedItem2.mensaje = null;
            })
            .catch((error) => {
              this.validarError(error);
            })
            .finally(() => {
              this.cargar = false;
            });
        })
        .catch((error) => {
          this.validarError(error);
        })
        .finally(() => {
          this.cargar = false;
        });
    },


    aceptarHorasExtras() {

      this.cargar = true;
      const payload = {
        estatus: 1,
        id: this.horaextramensaje.idhoras_extras,
      };

      return this.$http
        .post("horas_extras.update.estatus", payload)
        .then((response) => {
          this.dialogAceptar = false;
          this.horaextramensaje = null;
          this.initialize();
          this.cargar = false;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {});
    },

    goNomina(){
			this.$router.push({name: "Nomina"})
		},

    validarHoraFin() {
      if (
        this.editedItem.hora_inicio !== null &&
        this.editedItem.hora_fin !== null
      ) {
        // Obtener objetos de fecha y hora para hora_inicio y hora_fin
        const horaInicio = new Date(`2023-09-26T${this.editedItem.hora_inicio}`);
        const horaFin = new Date(`2023-09-26T${this.editedItem.hora_fin}`);

        // Realizar la comparación de horas
        if (horaFin <= horaInicio) {
          // Hora Fin es menor o igual a Hora Inicio, lo cual es inválido
          // Puedes manejar esto según tus necesidades, por ejemplo, mostrar un mensaje de error.
          // En este ejemplo, simplemente establecemos Hora Fin en nulo.
          this.editedItem.hora_fin = null;
        }
      }

    }


  },
};
</script>
